import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'
import { Platform } from 'react-native'

export const useCreateStyles = createStyleSheet((theme) => ({
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  key: {
    alignItems: 'center',
    borderRadius: 999,
    height: rh(56),
    justifyContent: 'center',
    width: rw(120),
    ...Platform.select({ web: { userSelect: 'none' as const, touchAction: 'manipulation' as const } }),
  },
  keyLabel: {
    color: theme.COLOR_TEXT_PRIMARY,
    userSelect: 'none',
  },
}))
